import { render, staticRenderFns } from "./EventTeamNotesDialog.vue?vue&type=template&id=7246e7ca&scoped=true&"
import script from "./EventTeamNotesDialog.vue?vue&type=script&lang=js&"
export * from "./EventTeamNotesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246e7ca",
  null
  
)

export default component.exports